/**
 * DateFieldButton - Date field button using existing hooks
 */

import {useDateTime} from '@hconnect/tuc-processes/fields/dateTime/useDateTime'
import moment from 'moment'
import React from 'react'
import {useTranslation} from 'react-i18next'

import {FieldButton} from '../../FieldButton'

interface DateFieldButtonProps {
  onClick: () => void
  requiresApproval?: boolean
  isReadOnly?: boolean
  isChanged?: boolean
}

export const DateFieldButton: React.FC<DateFieldButtonProps> = ({
  onClick,
  requiresApproval = false,
  isReadOnly = false,
  isChanged = false
}) => {
  const {t} = useTranslation()
  const {dateTime} = useDateTime()

  // Following useRmcOrderEditLogic pattern - return null instead of NOT_SPECIFIED
  const displayValue = dateTime && dateTime[0] ? moment(dateTime[0]).format('DD.MM.YYYY') : null

  return (
    <FieldButton
      label={t('orderIntake.rmc.orderManagement.editSteps.labels.date', 'Date')}
      value={displayValue}
      onClick={onClick}
      requiresApproval={requiresApproval}
      isReadOnly={isReadOnly}
      isChanged={isChanged}
    />
  )
}
